import { getPrimaryColor } from '../../theme/defaultThemeOperators';
export const getNanoProgressColor = getPrimaryColor;